
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/in-your-community",
      function () {
        return require("private-next-pages/in-your-community/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/in-your-community"])
      });
    }
  